import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { map } from 'rxjs';
import type { SmsTextsComponent } from './sms-texts.component';
import { UnsavedSmsTextsDialogComponent } from './unsaved-sms-texts-dialog.component';

export const confirmSmsTextDrafts: CanDeactivateFn<SmsTextsComponent> = (
  component,
) => {
  if (!component.hasUnsavedChanges()) return true;
  return inject(MatDialog)
    .open(UnsavedSmsTextsDialogComponent, {
      width: '30rem',
      autoFocus: 'first-tabbable',
    })
    .afterClosed()
    .pipe(map((leave) => leave === true));
};
